import { Route, Routes } from 'react-router-dom';

import BookingConfirmation from 'pages/BookingConfirmation';
import Dashboard from 'pages/Dashboard';
import GroupRequest from 'pages/GroupRequest';
import GroupRooms from 'pages/GroupRooms';
import PaymentMethods from 'pages/PaymentMethods';
import SavedCardReturn from 'pages/SavedCardReturn';
import ShortList from 'pages/ShortList';
import TermsOfService from 'pages/TermsOfService';
import Trips from 'pages/Trips';
import { useAppSelector } from 'store/store';

import AdminOnlyRoute from '../components/AdminOnlyRoute';
import InactiveClientRouteGuard from '../components/InactiveClientRouteGuard';
import TravelerSelfBookingGuard from '../components/TravelerSelfBookingGuard';
import Wrapper from '../components/Wrapper';
import {
  HotelClientGate,
  SelectHotelClient,
  UnsupportedHotelLink,
} from '../hotel/HotelClientGate';
import { Navigate } from '../hotel/navigation';

import Contact from './Contact';
import HotelSearch from './HotelSearch';
import Landing from './Landing';
import Playground from './Playground';
import Requests from './Requests';
import Roster from './Roster';
import SelfBooking from './SelfBooking';

const HotelRoutes = () => {
  const bookingType = useAppSelector((state) => state.booking.bookingType);
  const isGroupBooking = bookingType === 'group';

  return (
    <Routes>
      <Route element={<Wrapper />}>
        <Route index element={<Navigate replace to="/dashboard" />} />
        <Route path="dashboard/*" element={<Dashboard />} />
        <Route
          path="groups/*"
          element={
            <AdminOnlyRoute>
              {isGroupBooking ? (
                <GroupRooms />
              ) : (
                <Navigate replace to={'/dashboard'} />
              )}
            </AdminOnlyRoute>
          }
        />
        <Route
          path="shortlist/*"
          element={
            <AdminOnlyRoute>
              {isGroupBooking ? (
                <ShortList />
              ) : (
                <Navigate replace to={'/dashboard'} />
              )}
            </AdminOnlyRoute>
          }
        />
        <Route
          path="group_request/*"
          element={
            <AdminOnlyRoute>
              {isGroupBooking ? (
                <InactiveClientRouteGuard>
                  <GroupRequest />
                </InactiveClientRouteGuard>
              ) : (
                <Navigate replace to={'/dashboard'} />
              )}
            </AdminOnlyRoute>
          }
        />
        <Route path="roster/*" element={<Roster />} />
        <Route path="requests/*" element={<Requests />} />
        <Route path="trips/*" element={<Trips />} />
        <Route path="contact/*" element={<Contact />} />
        <Route path="payment-methods" element={<PaymentMethods />} />
        <Route path="playground/*" element={<Playground />} />
        <Route
          path="search/*"
          element={
            <TravelerSelfBookingGuard>
              <HotelSearch />
            </TravelerSelfBookingGuard>
          }
        />
        <Route
          path="selfbooking/*"
          element={
            <InactiveClientRouteGuard>
              <TravelerSelfBookingGuard>
                <SelfBooking />
              </TravelerSelfBookingGuard>
            </InactiveClientRouteGuard>
          }
        />
        <Route path="booking-confirmation" element={<BookingConfirmation />} />
        <Route
          path="booking-confirmation/:bookingId"
          element={<BookingConfirmation />}
        />
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" />} />
    </Routes>
  );
};

const RoutesIndex = () => (
  <Routes>
    <Route index element={<Landing />} />
    <Route path="terms" element={<TermsOfService />} />
    <Route path="terms/:versionId" element={<TermsOfService />} />
    <Route path="select-client" element={<SelectHotelClient />} />
    <Route path="saved-card-return" element={<SavedCardReturn />} />
    <Route
      path="clients/:clientId/*"
      element={
        <HotelClientGate>
          <HotelRoutes />
        </HotelClientGate>
      }
    />
    <Route path="*" element={<UnsupportedHotelLink />} />
  </Routes>
);

export default RoutesIndex;
